/**
 * The backend refuses "+" aliases for new accounts (one inbox, many trials),
 * except for these team members, who use them to test; mirrored here so a form
 * says so up front. Keep in step with services/auth/business-logic/email-rules.js.
 *
 * The names are matched against the part before the "+", so "ali.hamza+8@…" is
 * allowed and "test+hamza@…" is not.
 */
export const PLUS_ALIAS_ALLOWED_NAMES = ['hamza', 'mina', 'ghous'];

export const PLUS_ALIAS_MESSAGE = `Email addresses with a "+" aren't supported. Please use your regular email address.`;

export const hasBlockedPlusAlias = value => {
  const [local = ''] = String(value || '')
    .trim()
    .toLowerCase()
    .split('@');
  if (!local.includes('+')) return false;
  const [base] = local.split('+');
  return !PLUS_ALIAS_ALLOWED_NAMES.some(name => base.includes(name));
};
